/* eslint-disable react/prop-types */
import React from 'react';
import { Picker, Item } from '@adobe/react-spectrum';
import { useAsyncList } from '@react-stately/data';

import PropTypes from 'prop-types';
import actionWebInvoke from '../../../utils/actionCallUtils';
import actions from '../../../config.json';
import OBJCODE from '../../../constants';

function DynamicList(props) {
  const { name, label, param, paramValue, handleChange } = props;
  const list = useAsyncList({
    async load() {
      const queryParams = {
        [param]: paramValue,
      };
      const res = await actionWebInvoke(
        actions['workfront-action'],
        {},
        { objCode: OBJCODE.CSTEM_SEARCH, queryParams },
      );
      return {
        items: res,
      };
    },
  });

  return (
    <Picker
      label={label}
      name={name}
      items={list.items}
      isLoading={list.isLoading}
      onSelectionChange={selected => handleChange(name, selected)}
      onLoadMore={list.loadMore}
    >
      {item => <Item key={item.value}>{item.label}</Item>}
    </Picker>
  );
}

DynamicList.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  param: PropTypes.string,
  paramValue: PropTypes.string,
  handleChange: PropTypes.func,
};

DynamicList.defaultProps = {
  name: '',
  label: '',
  param: '',
  paramValue: '',
  handleChange: () => {},
};

export default DynamicList;
